import { Facebook, Instagram, Linkedin, Youtube, MapPin, Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import { siteLocation } from "@/data/location";
import { useI18n } from "@/i18n";

export function SiteFooter() {
  const { t } = useI18n();

  const navLinks = [
    { label: t.footer.links[0], to: "/catalog" },
    { label: t.footer.links[1], to: "/#financing" },
    { label: t.footer.links[2], to: "/#contact" },
    { label: t.footer.links[3], to: "/#about" },
    { label: t.footer.links[4], to: "/#contact" },
    { label: t.footer.links[5], to: "/#about" },
  ];

  return (
    <footer className="relative border-t border-border bg-surface">
      <div className="pointer-events-none absolute inset-x-0 -top-px h-px bg-gradient-to-r from-transparent via-primary/60 to-transparent" />
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 lg:grid-cols-4 lg:px-8">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3">
            <div className="grid h-10 w-10 place-items-center rounded-md bg-gradient-to-br from-primary to-primary/30 shadow-[var(--shadow-glow)]">
              <span className="font-display text-base font-bold text-primary-foreground">M</span>
            </div>
            <div>
              <div className="font-display text-lg font-semibold">Meridian Motors</div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
                {t.footer.tagline}
              </div>
            </div>
          </div>
          <p className="mt-6 max-w-md text-sm leading-relaxed text-muted-foreground">
            {t.footer.blurb}
          </p>
          <div className="mt-6 flex gap-3">
            {[Instagram, Facebook, Linkedin, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                aria-label={t.footer.social}
                className="grid h-10 w-10 place-items-center rounded-full border border-border text-muted-foreground transition-all hover:-translate-y-0.5 hover:border-primary hover:text-primary"
              >
                <Icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-muted-foreground">
            {t.footer.showroom}
          </h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li className="flex gap-3 text-muted-foreground">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
              <span>
                {siteLocation.addressLine1}
                <br />
                {siteLocation.addressLine2}
              </span>
            </li>
            <li className="flex gap-3 text-muted-foreground">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
              <a href={`tel:${siteLocation.phoneTel}`} className="hover:text-foreground">
                {siteLocation.phoneDisplay}
              </a>
            </li>
            <li className="flex gap-3 text-muted-foreground">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
              <a href={`mailto:${siteLocation.email}`} className="hover:text-foreground">
                {siteLocation.email}
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-semibold uppercase tracking-wider text-muted-foreground">
            {t.footer.navigate}
          </h4>
          <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
            {navLinks.map((n) => (
              <li key={n.label}>
                <Link to={n.to} className="transition-colors hover:text-foreground">
                  {n.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-border">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-6 text-xs text-muted-foreground sm:flex-row sm:px-6 lg:px-8">
          <p>
            © {new Date().getFullYear()} Meridian Motors. {t.footer.rights}
          </p>
          <div className="flex gap-6">
            <a href="#" className="hover:text-foreground">
              {t.footer.privacy}
            </a>
            <a href="#" className="hover:text-foreground">
              {t.footer.terms}
            </a>
            <a href="#" className="hover:text-foreground">
              {t.footer.accessibility}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
